import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";
import QuotationMain from "./QuotationMain";
import DownloadApp from "../home/DownloadApp";

const Quotation = () => {
  return (
    <>
      <Header parentMenu="contact" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Quotation" />
          <QuotationMain />
          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}
          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Quotation;
